// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueI18n from 'vue-i18n'
import App from "./App";
import router from "./router";
import store from "./store/store.js";
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import {description} from '../package.json'
import elEn from 'element-ui/lib/locale/lang/en' //Element-UI国际化所需
import elZh from 'element-ui/lib/locale/lang/zh-CN' //Element-UI国际化所需
import en from '@/assets/language/en'
import zh from '@/assets/language/zh'
import { Loading } from 'element-ui';

// ================= Vue Plugins =================
Vue.use(VueI18n);
Vue.use(VueMoment, { moment });

Vue.config.productionTip = false;

// ================= i18n =================
export const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "en",
  messages: {
    en: { ...en, ...elEn },
    zh: { ...zh, ...elZh }
  }
});

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});


import axios from "axios";
import Qs from "qs";
// ================= Axios Global Config =================
axios.defaults.transformRequest = [
  function (data) {
    if (data && data.toString() === "[object FormData]") {
      return data;
    }
    return Qs.stringify(data);
  }
];

// ================= App Init =================
function initApp() {
  let isLoggingOut = false;
  const CancelToken = axios.CancelToken;
  const cancelSource = CancelToken.source();
  let instance = null;

  // ---------- axios instance ----------
  let lineURL = localStorage.getItem("lineUrl");

  if (!lineURL) {
    localStorage.setItem("lineUrl", process.env.API_ROOT);
    localStorage.setItem("lineUrlText", "pc.header.line1");
    localStorage.setItem("lineUrlId", "1");

    instance = axios.create({
      baseURL: process.env.API_ROOT,
      timeout: 10000,
      withCredentials: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
      }
    });
  } else {
    instance = axios.create({
      baseURL: lineURL,
      timeout: 10000,
      withCredentials: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
      }
    });

    if (!localStorage.getItem("encript_public_key")) {
      localStorage.setItem(
        "encript_public_key",
        process.env.PUBLIC_ENCRYPTION_KEY
      );
    }
  }

  // ---------- request interceptor ----------
  instance.interceptors.request.use(
    config => {
      const lang = localStorage.getItem("locale") || i18n.locale || "en";
      config.headers["Accept-Language"] = lang;
      config.cancelToken = cancelSource.token;
      return config;
    },
    error => Promise.reject(error)
  );

  // ---------- response interceptor ----------
  instance.interceptors.response.use(
    response => {
      const res = response.data;

      if (res && res.code === -1) {
        if (!isLoggingOut) {
          isLoggingOut = true;
          cancelSource.cancel("Session expired");
          ElementUI.Message.error(i18n.t(res.msg) || "登录失效，请重新登录");

          store.commit("changeLoginType", false);
          store.commit("clearStore");

          sessionStorage.clear();
          localStorage.clear();

          setTimeout(() => {
            router.push("/login");
            window.location.reload();
          }, 1000);
        }
        return Promise.reject(new Error(res.msg || "Session expired"));
      }

      return response;
    },
    error => {
      if (axios.isCancel(error)) {
        return new Promise(() => {});
      }
      return Promise.reject(error);
    }
  );

  Vue.prototype.$http = instance;
  Vue.prototype.$URLs = [
    { id: 1, name: "pc.header.line1", url: process.env.API_ROOT },
    { id: 2, name: "pc.header.line2", url: process.env.Line_1 },
    { id: 3, name: "pc.header.line3", url: process.env.Line_2 }
  ];

  Vue.prototype.$chatApiURL = "https://hkchatapp.hk9999z.com";
  Vue.prototype.$dataSource = "shuhai";

  Vue.prototype.$getDeviceTime = function (utcTime) {
    const date = new Date(utcTime);
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60000);
    return localDate
      .toLocaleString("sv-SE", { hour12: false })
      .replace("T", " ")
      .replace(/-/g, ".");
  };

  Vue.prototype.$getDeviceDate = function (utcDate) {
    const date = new Date(utcDate);
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60000);
    const Y = localDate.getFullYear();
    const M = String(localDate.getMonth() + 1).padStart(2, "0");
    const D = String(localDate.getDate()).padStart(2, "0");
    return `${Y}.${M}.${D}`;
  };

  Vue.prototype.$loadLangAsync = function () {
    const loading = Loading.service({ fullscreen: true });
    const lang = localStorage.getItem("locale") || i18n.locale || "en";

    return instance({
      url: "/",
      method: "post",
      data: {
        nozzle: "i118_language",
        device: "pc"
      }
    })
      .then(res => {
        if (res.data.code === 1) {
          i18n.setLocaleMessage(lang, res.data.data);
        }
        loading.close();
        return true;
      })
      .catch(() => {
        loading.close();
        return false;
      });
  };

  Vue.prototype.$loadLangAsync();

  new Vue({
    el: "#app",
    i18n,
    router,
    store,
    render: h => h(App)
  });

  router.afterEach(() => {
    window.scrollTo(0, 0);
  });
}
initApp();



// WEBPACK FOOTER //
// ./src/main.js